import { SVGProps, Ref, forwardRef } from 'react';

export const ArrowDownRightOutlinedSize16Glyph = forwardRef(
    (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
        <svg
            width={16}
            height={16}
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ref={ref}
            {...props}
        >
            <g>
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M1 1h1.4v1.667c0 1.905.001 3.264.14 4.296.136 1.011.393 1.603.827 2.037s1.026.69 2.037.827c1.032.138 2.39.14 4.296.14h2.62L9.677 7.324l.99-.99L15 10.667 10.667 15l-.99-.99 2.643-2.643H9.647c-1.84 0-3.293 0-4.43-.153-1.166-.157-2.103-.486-2.84-1.224-.738-.737-1.067-1.674-1.224-2.84C1 6.012 1 4.56 1 2.72z"
                    fill="currentColor"
                />
            </g>
        </svg>
    )
);
ArrowDownRightOutlinedSize16Glyph.displayName = 'ArrowDownRightOutlinedSize16Glyph';
